<script setup>
// Serve la const props per poter usare listaAmbiti in setup
// defineProps senza la reference della const non permette di usare le props in setup
const props = defineProps({
  listaAmbiti: {
    type: Array,
    default: () => [],
  },
})

const listaAmbitiRef = ref(props.listaAmbiti)

const half = computed(() => Math.ceil(listaAmbitiRef.value.length / 2))

const firstHalf = computed(() => listaAmbitiRef.value.slice(0, half.value))
const secondHalf = computed(() => listaAmbitiRef.value.slice(half.value))
</script>

<template>
  <div class="p-bot-1">
    <div v-if="listaAmbitiRef.length > 0" class="row-400-20 ambiti-list max">
      <div class="column-1">
        <div
          v-for="(item, index) in firstHalf"
          :key="'first-half-' + index"
          class="ambito"
          :class="[
            'ambito',
            { 'last-item-column-1': index === firstHalf.length - 1 },
          ]"
        >
          <nuxt-link
            v-if="item.slug"
            class="text-4"
            :to="
              $localePath({
                name: 'ambiti-slug',
                params: { slug: item.slug },
              })
            "
          >
            <div class="icon-link-animation">
              <div v-if="item.titolo" class="text">
                {{ item.titolo }}
              </div>
              <div class="icon-container">
                <div class="icon">
                  <img src="@/assets/img/ico/arrows-color2.svg" alt="Icon" />
                </div>
                <div class="icon-hover">
                  <img src="@/assets/img/ico/arrows-color3.svg" alt="Icon" />
                </div>
              </div>
            </div>
          </nuxt-link>
        </div>
      </div>
      <div class="column-2">
        <div>
          <div
            v-for="(item, index) in secondHalf"
            :key="'second-half-' + index"
            class="ambito"
            :class="[
              'ambito',
              { 'last-item': index === secondHalf.length - 1 },
            ]"
          >
            <nuxt-link
              v-if="item.slug"
              class="text-4"
              :to="
                $localePath({
                  name: 'ambiti-slug',
                  params: { slug: item.slug },
                })
              "
            >
              <div class="icon-link-animation">
                <div v-if="item.titolo" class="text">
                  {{ item.titolo }}
                </div>
                <div class="icon-container">
                  <div class="icon">
                    <img src="@/assets/img/ico/arrows-color2.svg" alt="Icon" />
                  </div>
                  <div class="icon-hover">
                    <img src="@/assets/img/ico/arrows-color3.svg" alt="Icon" />
                  </div>
                </div>
              </div>
            </nuxt-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AmbitiList',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
